import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            移动入口
          </h2>
          <p className="text-sm text-foreground-500 mb-2">{appData.subtitle}</p>
          <p className="text-sm text-foreground-600 leading-relaxed mb-8">
            {appData.description}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            {appData.features.map((feat, i) => (
              <div key={i} className="flex flex-col items-center gap-2 p-4 bg-background-50 border border-background-200/60 rounded-lg">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                  <i className={`${feat.icon} text-lg`}></i>
                </span>
                <span className="text-xs text-foreground-600 whitespace-nowrap">{feat.text}</span>
              </div>
            ))}
          </div>

          <a
            href="#topics"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-8 py-3 rounded-md transition-all duration-200 cursor-pointer text-sm"
          >
            <i className="ri-smartphone-line w-5 h-5 flex items-center justify-center"></i>
            访问移动端入口
          </a>
        </div>
      </div>
    </section>
  );
}